module.exports = __webpack_public_path__ + "img/rider_marker.309e7f32.png";